<div class="error-page">
  <lds-empty-state
    [heading]="title"
    [message]="message">
  </lds-empty-state>

  <div class="error-page__actions">
    <lds-button
      appearance="action"
      (click)="onBackClick()">
      {{ backLabel }}
    </lds-button>
  </div>
</div>

